import { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import HeroSlider from "../../components/authforms/authsideimage";
import AuthLogo from "../../components/logo/authlogo";
import ErrorBoundary from "../../components/errorboundary/errorboundary";
import signup from "../../assets/images/auth/signup.jpg";
import login from "../../assets/images/auth/login2.jpg";
import verify from "../../assets/images/auth/verify.jpg";
import forgotpassword from "../../assets/images/auth/forgotpassword.jpg";
import _route from "../../constants/routes";
import Icon from "../../components/icon/icons";

const SLIDE_CONTENT = {
  title: "Join The Human Development Lab",
  description:
    "Design, fund, and implement a real humanitarian project in Kenya. Receive up to $5,000 in project funding and travel to see your impact.",
  list: [
    "Submit your proposal",
    "Get selected by expert judges",
    "Raise funds and implement your vision",
  ],
};

export default function AuthLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const slides = useMemo(() => {
    const currentPath = location.pathname;
    const slideMap = {
      [_route._signup]: { id: 1, image: signup, ...SLIDE_CONTENT },
      [_route._login]: { id: 2, image: login, ...SLIDE_CONTENT },
      [_route._verify]: { id: 3, image: verify, ...SLIDE_CONTENT },
      [_route._forgot_password]: { id: 4, image: forgotpassword, ...SLIDE_CONTENT },
    };

    const activeSlide = slideMap[currentPath];
    return activeSlide ? [activeSlide] : [];
  }, [location.pathname]);

  return (
    <div className="relative flex flex-row-reverse h-[100svh] md:h-screen bg-[#FFFFFF] transition-colors duration-700 md:p-2">
      {/* Back button */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="absolute left-4 cursor-pointer top-4 z-20 inline-flex h-8 w-8 items-center justify-center rounded-md bg-grey-900 text-grey-560 shadow-sm hover:bg-grey-700"
        aria-label="Go back"
      >
        <Icon name="backarrow2" iconClass="w-3 h-3 text-grey-818" />
      </button>

      {/* Content */}
      <div className="relative z-10 flex flex-row w-full h-full">
        <div className="flex flex-col w-full md:w-1/2 py-5 justify-center max-w-3xl mx-auto">
          <div className="w-full mx-auto mt-auto mb-14">
            <AuthLogo jstlogo className="mx-auto" />
          </div>
          <div className="px-7 lg:px-14 flex w-full mb-auto overflow-scroll client-overflow-scroll">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
        </div>
        <div className="w-1/2 relative hidden md:flex flex-col">
          <ErrorBoundary>
            <HeroSlider slides={slides} />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
}
